
import { Button, Pagination } from "react-bootstrap"
import { Search } from "./icons";
import clsx from "clsx";
import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import formRender from './renderer';
import { useLocation, useSearchParams } from "react-router-dom";

const pageSizes = [
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 30, value: 30 },
    { label: 40, value: 40 }
];

const filterConfig = [
    {
        default: 10,
        options: pageSizes,
        type: "select",
        labelContainerStyle: {
            display: "none"
        },
        key: "limit"
    },
    {
        defaultValue: "",
        key: "recent",
        labelContainerStyle: {
            display: "none"
        },
        type: "select",
        options: [
            {
                value: "",
                label: "All"
            },
            {
                value: "10",
                label: "Recent"
            }
        ]
    },
    {
        default: "Search",
        type: 'search',
        key: "search"
    },
    {
        default: "By Type",
        key: "jobType",
        type: "select",
        labelContainerStyle: {
            display: "none"
        },
        options: [
            {
                value: "",
                label: "By Type"
            },
            {
                value: "onsite",
                label: "Onsite"
            },
            {
                value: "remote",
                label: "Remote"
            },
            {
                value: "hybrid",
                label: "Hybrid"
            }
        ]
    },
    {
        default: "By Role",
        key: "date",
        type: "date",
        placeholder: "Role",
        labelContainerStyle: {
            display: "none"
        }
    }
]

export function Filters() {
    const [filterValues, setFilterValues] = useState<any>({});
    const { onFilter } = useSelector((state: any) => state.appReducer.filter);
    const [params, setQueryParams] = useSearchParams();
    const [oldPath, setOldPath] = useState('')
    const location = useLocation();
    useEffect(() => {

        if (oldPath && location.pathname !== oldPath) {
            setQueryParams({});
            setFilterValues({});
            return;
        }
        let param: any = {}
        for (let [key, value] of params.entries()) {
            param[key] = value;
        };
        setFilterValues(param);
        setOldPath(location.pathname)

    }, [location.pathname])

    const onChange = (e: any) => {
        const { name, value } = e.target;
        setFilterValues((prev: any) => ({ ...prev, [name]: value }))
    }

    const clearFilter = (e: any) => {
        setQueryParams([]);
        setFilterValues({});
    }


    const filter = () => {
        let newParams = new URLSearchParams();
        Object.keys(filterValues).forEach(key => {
            if (filterValues[key]) {
                newParams.set(key, filterValues[key]);
            }
        });

        newParams.set("page", "1");
        setQueryParams(newParams);
    };


    return <div className={`filters `}>

        {filterConfig.map((menuItem, i) => {
            if (menuItem.type === 'search') {
                return <div key={i} className={clsx('search')} >
                    {filterValues[menuItem.key] === '' && <Search className="fa fa-search" />}
                    <input
                        className="search-tab"
                        onChange={onChange}
                        value={filterValues[menuItem.key] || ''}
                        name={menuItem.key}
                        placeholder={"Search By Job or Location"}
                    />
                </div>
            }
            return <React.Fragment key={i} >
                {formRender({
                    ...menuItem,
                    binder: filterValues[menuItem.key] || "",
                    returnOnlyInput: true,
                    className: clsx("select"),
                    onChange
                })
                }
            </React.Fragment>

        })}
        <Button onClick={filter} className=" filter-btn-jobs btn-purple-light ml-3">
            Filter Jobs
        </Button>
        <Button onClick={clearFilter} className="btn-purple-light reset-btn-jobs">
            Reset Filter
        </Button>
    </div>
}

export function AppPagination({ pages = 0 }) {
    const [params, setParams] = useSearchParams();
    const page = params.get("page") || 1;
    let items = [];
    const onClick = (number: any) => {
        const param: any = { page: number };
        params.set("page", number)
        setParams(params)
    }
    for (let number = 1; number <= pages; number++) {
        items.push(
            <Pagination.Item onClick={() => onClick(number)} key={number} active={number === page}>
                {number}
            </Pagination.Item>,
        );
    }
    if (items.length < 2) {
        return null;
    }
    return <Pagination size="sm">{items}</Pagination>
}
